'use client';

import { UserDTO } from '@/shared/user/user.dto';
import { useHasActiveZangiaPlus } from '@/features/jobs/hooks/useHasActiveZangiaPlus';
import ZangiaPlusComponent from './ZangiaPlusComponent';
import ZangiaPlusLockedComponent from './ZangiaPlusLockedComponent';
import ZangiaPlusNoSentComponent from './ZangiaPlusNoSentComponent';

type ZangiaPlusJobInsightSectionProps = {
  jobId: number;
  isSent: boolean;
  jobDetailKey?: string | number;
  jobTime?: number | string;
  isEnglish?: boolean;
  showCollapseButton?: boolean;
  user?: UserDTO | null;
};

export function ZangiaPlusJobInsightSection({
  jobId,
  isSent,
  jobDetailKey,
  jobTime,
  isEnglish = false,
  showCollapseButton = false,
  user: userProp,
}: ZangiaPlusJobInsightSectionProps) {
  const { hasPlus, isAuthLoading } = useHasActiveZangiaPlus(userProp);

  if (isAuthLoading) {
    return (
      <section className="my-6 overflow-hidden rounded-xl border border-gray-200 bg-white p-5">
        <div className="mb-3 h-6 w-28 animate-pulse rounded-lg bg-gray-200" />
        <div className="h-4 w-full max-w-md animate-pulse rounded bg-gray-100" />
      </section>
    );
  }

  if (hasPlus) {
    if (!isSent) {
      return <ZangiaPlusNoSentComponent isEnglish={isEnglish} />;
    }
    return (
      <ZangiaPlusComponent
        jobId={jobId}
        jobDetailKey={jobDetailKey}
        jobTime={jobTime}
        isEnglish={isEnglish}
        showCollapseButton={showCollapseButton}
      />
    );
  }

  return <ZangiaPlusLockedComponent isEnglish={isEnglish} />;
}
